import { theme } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { CsVulnerabilityIcon } from '../../../../legacy-design-system/icons'
import { WithTooltip } from '../../../../design-system'
import { CvssScoringType } from '../../helpers/ui-interfaces'
import { getSeverityBadgeColor } from './tree-node'

export const renderVulnTooltip = (
  vulnerabilities,
  vulnerabilitySeverities,
  cvssScoringType: CvssScoringType
) => {
  return (
    <div
      className={css`
        float: right;
        margin-left: 15px;
        margin-top: 2px;
      `}
    >
      <FormattedMessage
        id="detail_libraries_numberOfVulnerabilities"
        values={{ numberOfVulnerabilities: vulnerabilities.length }}
      >
        {(tooltipTitle) => (
          <WithTooltip
            renderTooltipContent={() => tooltipTitle}
            children={() => (
              <CsVulnerabilityIcon
                size={16}
                color={getSeverityBadgeColor(
                  vulnerabilitySeverities,
                  cvssScoringType
                )}
              />
            )}
          />
        )}
      </FormattedMessage>
    </div>
  )
}

export const renderChildVulnerableTooltip = () => {
  return (
    <div
      className={css`
        display: inline-block;
        margin-left: 15px;
        margin-top: 2px;
      `}
    >
      <FormattedMessage id="detail_libraries_hasVulnerableDependecies">
        {(tooltipTitle) => (
          <WithTooltip
            tiny
            placement="right"
            renderTooltipContent={() => tooltipTitle}
            children={() => (
              <CsVulnerabilityIcon
                data-testid="cve_icon_indicator"
                color={theme.color.neutral60}
                size={16}
              />
            )}
          />
        )}
      </FormattedMessage>
    </div>
  )
}
